import React from 'react';
import { CognocracyHero } from '../../components/cognocracy/CognocracyHero';
import { CognocracyFoundation } from '../../components/cognocracy/CognocracyFoundation';
import { CognocracyCredential } from '../../components/cognocracy/CognocracyCredential';
import { CognocracyGovernance } from '../../components/cognocracy/CognocracyGovernance';
import { RelatedInitiative } from '../../components/initiatives/RelatedInitiative';
export function CognocracyPage() {
  return <>
      <CognocracyHero data-id="element-3143" data-mp="12c26lstgyij7" />
      <CognocracyFoundation data-id="element-3144" data-mp="12ctv6jonffzz" />
      <CognocracyCredential data-id="element-3145" data-mp="12dn67wun4rnx" />
      <RelatedInitiative label="Supporting Research" name="Publication plans" body="Planned concept notes, technical designs and assessment protocols related to Cognocracy’s proposed model. No completed studies are published yet." href="/roadmap#publications" linkLabel="View publication plans" data-id="element-3146" data-mp="12a7nmk1rd0hr" />
      <CognocracyGovernance data-id="element-3147" data-mp="jkj7hx2kfomg" />
    </>;
}